<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-alert transition="expand-transition" border="left" text type="error" v-if="mensagemUnidade">
      {{ mensagemUnidade }}
    </v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Solicitar Produtos'"
      :newRowmodalButtonText="'Nova Solicitação'"
      :tableHeader="headers"
      :tableRows="listSolicitarItem"
      :isEdit="false"
      :isFinish="false"
      :isDel="true"
      :isPrint="true"
      :solicitar="true"
      :totalItens="total"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
      v-on:datatable-print="gerarPdfDeSolicitacao"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>

        <v-col cols="12">
          <v-form v-model="isFormValid">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-checkbox label="Solicitar testagem rápida" v-model="modalCustomSize.actualEdit.indicadorTipoSolicitacao" :false-value="0" :true-value="1"></v-checkbox>
                <v-alert transition="expand-transition" border="left" text type="error" v-if="modalCustomSize.actualEdit.indicadorTipoSolicitacao">
                  Solicitações de testes rápidos estão liberadas somente na Segunda-feira e Terça-feira !
                </v-alert>
              </v-col>

              <v-col cols="12" class="pt-0">
                <v-text-field v-model="modalCustomSize.actualEdit.descricaoSolicitarItem" name="descricaoSolicitarItem" label="Descrição da Solicitação" counter="255" :rules="[rules.required, rules.limitCharacters]"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-autocomplete label="Lista de Produtos" :items="listOfItens" v-model="itemSelecionado"> </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <v-text-field v-model="searchItensSolicitados" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
                  </v-card-title>

                  <v-data-table :headers="headersItensSolicitados" :search="searchItensSolicitados" :items="modalCustomSize.actualEdit.listaDeItensSolicitados" disable-sort>
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Produtos Solicitados</v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>

                    <template v-slot:[`item.quantidadeEstoque`]="{ item }">
                      {{ formatarQuantidade(item.quantidadeEstoque) }}
                    </template>

                    <template v-slot:[`item.quantidadeSolicitada`]="props">
                      <v-text-field style="max-width:250px" v-model="props.item.quantidadeSolicitada" :rules="[rules.required]" label="Quantidade Solicitar" single-line @keypress="(event) => filter(event)"></v-text-field>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small class="mr-2" @click="modalUltimasDispensas(item)" v-bind="attrs" v-on="on">
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>Visualizar saída mensal</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small @click="deleteItemFromList(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>

              <v-col v-if="modalCustomSize.actualEdit.observacaoSolicitacao" cols="12">
                <v-textarea v-model="modalCustomSize.actualEdit.observacaoSolicitacao" name="descricaoObservacao" label="Observação" rows="3" row-height="20" readonly />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </ModalCustomSize>

    <ModalCustomSize
      :modalSize="'600px'"
      :isTheModalOpen="modalCustomSizeUlimasDispensas.isOpen"
      :modalButtonText="modalCustomSizeUlimasDispensas.buttonText"
      :modalFormTitle="modalCustomSizeUlimasDispensas.formTitle"
      :modalType="modalCustomSizeUlimasDispensas.modalType"
      :isModalButtonVisible="modalCustomSizeUlimasDispensas.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeUlimasDispensas.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSizeUlimasDispensas.isOpen = false"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-row class="pa-0">
        <v-col cols="12" class="pa-0">
          <v-data-table :headers="verificaUnidade($store.state.numeroEndereco) ? headerUltimasDispensasZSaude : headerUltimasDispensas" :search="searchUltimasDispensas" :items="modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas" hide-default-footer>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Totais Dispensados</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              {{ formataMes(item.mes) }}
            </template>

            <template v-slot:[`item.quantidadeTotalProcesso`]="{ item }">
              {{ item.quantidadeTotalProcesso.toFixed(2) }}
            </template>

            <template v-slot:[`item.quantidadeTotalUnidade`]="{ item }">
              {{ item.quantidadeTotalUnidade.toFixed(2) }}
            </template>

            <template v-slot:[`item.quantidadeTotal`]="{ item }">
              {{ verificaUnidade($store.state.numeroEndereco) ? item.quantidadeTotal.toFixed(2) : item.quantidadeTotal }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </ModalCustomSize>
    <DeleteItemModal :textModalDelete="modalDelete.textModalDelete" :showModalDelete="modalDelete.closeModal" :buttomTextModalDelete="'Excluir'" v-on:on-response-modal-delete="deleteSolicitacao" v-on:close-modal="modalDelete.closeModal = false"></DeleteItemModal>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import axiosZSaude from "../plugins/axios_integracao";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    Alertas,
    AlertasModal,
    SkeletonTable,
    AlertaSnackbar,
  },

  sockets: {
    reciveUpdate: function(data) {
      if (data && data.descricaoTela == "solicitacaoDeItens" && data.numeroEndereco == this.$store.getters.numeroEndereco) {
        this.alertaSocket.texto = "Status da Solicitação " + data.numeroSolicitarItem + " - " + data.descricaoSolicitacaoItem + " atualizada!";
        this.alertaSocket.tipo = "info";
        this.initialize();
      }
    },
  },

  data: () => ({
    //Paginação
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    searchUltimasDispensas: null,

    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    showSkeletonTable: true,
    loading: false,
    isFormValid: false,
    searchItensSolicitados: "",

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "solicitarItem.numeroSolicitacaoItem",
      },
      {
        text: "Descrição da Solicitação",
        value: "solicitarItem.descricaoSolicitarItem",
      },
      {
        text: "Data da Solicitação",
        value: "solicitarItem.dataSolicitarItem",
      },
      {
        text: "Status da Solicitação",
        value: "solicitarItem.indicadorStatusSolicitarItem",
      },
      {
        text: "Tipo Solicitação",
        value: "solicitarItem.indicadorTipo",
      },
      {
        text: "Observação de Edição",
        value: "solicitarItem.observacaoSolicitarItem",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensSolicitados: [
      {
        text: "ID",
        value: "numeroItemSistemaUnidade",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Quantidade Estoque",
        value: "quantidadeEstoque",
      },
      {
        text: "Quantidade Solicitada (Digite abaixo)",
        value: "quantidadeSolicitada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headerUltimasDispensas: [
      {
        text: "Mês",
        value: "mes",
      },
      {
        text: "Total por Paciente",
        value: "quantidadeTotalPaciente",
      },
      {
        text: "Total por Setor",
        value: "quantidadeTotalSetor",
      },
      {
        text: "Total",
        value: "quantidadeTotal",
      },
    ],

    headerUltimasDispensasZSaude: [
      {
        text: "Mês",
        value: "mes",
      },
      {
        text: "Total Procedimento",
        value: "quantidadeTotalProcesso",
      },
      {
        text: "Total Unidade",
        value: "quantidadeTotalUnidade",
      },
      {
        text: "Total",
        value: "quantidadeTotal",
      },
    ],

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        nomeEndereco: null,
        numeroSolicitarItem: null,
        descricaoSolicitarItem: null,
        observacaoSolicitacao: null,
        indicadorStatusSolicitarItem: null,
        indicadorTipoSolicitacao: 0,
        listaDeItensSolicitados: [],
        listaDeItensRemovidos: [],
        descricaoTela: "SolicitarItem",
      },
    },

    modalDelete: {
      solicitacaoSelecionada: null,
      closeModal: null,
      textModalDelete: "Você realmente deseja deletar essa Solicitação de Produto?",
      descricaoTela: "SolicitarItem",
    },

    modalCustomSizeUlimasDispensas: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsDisabled: false,
      isButtonsVisible: false,
      actualEdit: {
        ultimasDispensas: [],
      },
    },

    mensagemUnidade: null,

    //Array populado pela função initialize
    listSolicitarItem: [],
    listOfItens: [],
    itemSelecionado: null,
    filtrarPorKits: false,

    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: (v) => (v && v.length <= 255) || "Limite de 255 caracteres.",
    },
  }),

  created() {
    this.gerarNovoToken();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
    itemSelecionado() {
      if (this.itemSelecionado) {
        this.alertaSnackbar.mostrar = false;
        this.alertaModal.tipo = "";

        const verificarItem = this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade == this.itemSelecionado);

        if (verificarItem.length <= 0) {
          const itemInsert = this.listOfItens.filter((item) => item.numeroItemSistemaUnidade == this.itemSelecionado);

          this.modalCustomSize.actualEdit.listaDeItensSolicitados.unshift({
            numeroItemSistema: itemInsert[0].numeroItemSistema,
            numeroItemSistemaUnidade: itemInsert[0].numeroItemSistemaUnidade,
            nomeItemSistema: itemInsert[0].text,
            quantidadeEstoque: itemInsert[0].quantidadeEstoque,
          });

          this.modalCustomSize.isButtonsDisabled = true;
          this.itemSelecionado = "";
        } else {
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },
    "modalCustomSize.actualEdit.indicadorTipoSolicitacao"() {
      if (this.modalCustomSize.actualEdit.indicadorTipoSolicitacao == 1) {
        this.modalCustomSize.actualEdit.listaDeItensSolicitados = [];
        this.modalCustomSize.actualEdit.listaDeItensRemovidos = [];
        this.filtrarPorKits = true;
        this.listOfItensUnidade();
      } else {
        this.modalCustomSize.actualEdit.listaDeItensSolicitados = [];
        this.modalCustomSize.actualEdit.listaDeItensRemovidos = [];
        this.filtrarPorKits = false;
        this.listOfItensUnidade();
      }
    },
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        await this.retornarMensagemPedidoUnidade();
        await this.listOfSolicitacoes();
        await this.listOfItensUnidade();
      } catch (error) {
        console.log(error);
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async retornarMensagemPedidoUnidade() {
      try {
        let response = await axios.put("selecionarconfiguracaopedido", { numeroEndereco: store.state.numeroEndereco }, this.config);
        
        if(response.data.numeroConfiguracaoPedido) {
          this.mensagemUnidade = response.data.descricaoMensagem;
        } else {
          this.mensagemUnidade = "Solicitações estão liberadas somente na QUARTA-FEIRA, solicitações feitas nos demais dias são excluídas pelo sistema!";
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listOfSolicitacoes() {
      try {
        let response = await axios.put("listaDeSolicitacoes", { numeroEndereco: store.state.numeroEndereco, page: this.page, search: this.search }, this.config);
        if (!response.data || response.data.length > 0) {
          this.listSolicitarItem = response.data;
          this.total = response.data[0].solicitarItem.total;
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.listOfSolicitacoes();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.listOfSolicitacoes();
    },

    async listOfItensUnidade() {
      try {
        const responseItens = await axios.put("itemSistemaUnidade", { numeroEndereco: store.state.numeroEndereco, filtrarPorKits: this.filtrarPorKits, retornarSomenteAtivos: true }, this.config);

        this.listOfItens = responseItens.data.map((row) => {
          return {
            value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: row.itemSistema.nomeItemSistema,
            numeroItemSistema: row.itemSistema.numeroItemSistema,
            numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            quantidadeEstoque: row.quantidadeEstoqueTotal,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaUltimasDispensasProduto(numeroItemSistemaUnidade) {
      try {
        const response = await axios.put("totalultimasdispensas", { numeroItemSistemaUnidade: numeroItemSistemaUnidade }, this.config);
        return response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async listaUltimasDispensasProdutoZSaude(numeroUnidade, nomeProduto) {
      try {
        const response = await axiosZSaude.put("ultimasdispensas", { numeroUnidade: numeroUnidade, nomeProduto: nomeProduto }, this.config);
        return response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSize.isButtonsDisabled = true;
        if (this.modalCustomSize.isEdit) {
          await this.update(this.modalCustomSize.actualEdit);
        } else {
          await this.insert(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.isButtonsDisabled = false;
        this.initialize();
      }
    },

    async insert(reciveItem) {
      try {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        if (this.modalCustomSize.actualEdit.listaDeItensSolicitados.length > 0) {
          this.modalCustomSize.isLoadingRequestDisable = true;

          await axios.post("solicitarItem", reciveItem, this.config);
        
          this.modalCustomSize.isOpen = false;
          this.showSkeletonTable = true;
        } else {
          this.alertaModal.texto = "Não foi possível fazer a atualização, é necessario pelo menos um produto para fazer a solicitação!";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Não foi possível fazer a atualização, é necessario pelo menos um produto para fazer a solicitação!";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isButtonsDisabled = false;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        if (this.modalCustomSize.actualEdit.listaDeItensSolicitados.length > 0) {
          this.modalCustomSize.isLoadingRequestDisable = true;

          await axios.put("solicitarItem", reciveItem, this.config);
         
          this.modalCustomSize.isOpen = false;
          this.showSkeletonTable = true;
        } else {
          this.alertaModal.texto = "Não foi possível fazer a atualização, é necessario pelo menos um produto para fazer a solicitação!";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Não foi possível fazer a atualização, é necessario pelo menos um produto para fazer a solicitação!";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isButtonsDisabled = false;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async deleteSolicitacao() {
      try {
        this.alerta.tipo = "";

        this.modalCustomSize.isLoadingRequestDisable = true;
        this.modalDelete.solicitacaoSelecionada.descricaoTela = "SolicitarItem";
        await axios.delete("solicitarItem", {
          data: this.modalDelete.solicitacaoSelecionada,
          headers: this.config.headers,
        });
       
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.modalDelete.closeModal = false;
        this.initialize();
      }
    },

    async onDataTableUpdateRow(item) {
      this.loading = true;
      try {
        await this.verificarToken();

        this.alertaSnackbar.mostrar = false;
        this.alertaModal.tipo = "";
        this.searchItensSolicitados = "";
        this.modalCustomSize.actualEdit.numeroSolicitarItem = item.solicitarItem.numeroSolicitacaoItem;
        this.modalCustomSize.actualEdit.descricaoSolicitarItem = item.solicitarItem.descricaoSolicitarItem;
        this.modalCustomSize.actualEdit.indicadorStatusSolicitarItem = item.solicitarItem.indicadorStatusSolicitarItem;
        this.modalCustomSize.actualEdit.observacaoSolicitacao = item.solicitarItem.observacaoSolicitarItem;
        this.modalCustomSize.actualEdit.indicadorTipoSolicitacao = item.solicitarItem.indicadorTipo;
        this.modalCustomSize.actualEdit.listaDeItensRemovidos = [];

        let response = await axios.put("itensSolicitar", { numeroSolicitarItem: item.solicitarItem.numeroSolicitacaoItem }, this.config);
        this.modalCustomSize.actualEdit.listaDeItensSolicitados = response.data;

        this.itemSelecionado = null;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Atualizar Solicitação";
        this.loading = false;
      }
    },

    async onDataTableInsertRow() {
      await this.verificarToken();

      this.loading = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Nova Solicitação";
      this.alertaSnackbar.mostrar = false;
      this.alertaModal.tipo = "";
      this.modalCustomSize.actualEdit.observacaoSolicitacao = null;

      this.searchItensSolicitados = "";
      this.modalCustomSize.actualEdit.descricaoSolicitarItem = null;
      this.modalCustomSize.actualEdit.quantidadeSolicitada = null;
      this.modalCustomSize.actualEdit.numeroEnderecoItemSolicitado = null;
      this.modalCustomSize.actualEdit.indicadorTipoSolicitacao = 0;
      this.modalCustomSize.actualEdit.listaDeItensSolicitados = [];
      this.modalCustomSize.actualEdit.listaDeItensRemovidos = [];
      this.itemSelecionado = null;
      this.loading = false;
      this.modalCustomSize.isOpen = true;
    },

    async onDataTableDeleteRow(item) {
      await this.verificarToken();

      this.modalDelete.solicitacaoSelecionada = item;
      this.modalDelete.closeModal = true;
    },

    deleteItemFromList(value) {
      this.modalCustomSize.actualEdit.listaDeItensRemovidos.push(this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade == value.numeroItemSistemaUnidade)[0]);
      this.modalCustomSize.actualEdit.listaDeItensSolicitados = this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade != value.numeroItemSistemaUnidade);

      if (this.modalCustomSize.actualEdit.listaDeItensSolicitados.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },

    async modalUltimasDispensas(produtoSelecionado) {
      this.loading = true;
      try {
        if (this.verificaUnidade(store.state.numeroEndereco)) {
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = [];
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = await this.listaUltimasDispensasProdutoZSaude(this.retornaNumeroUnidadeZSaude(store.state.numeroEndereco), produtoSelecionado.nomeItemSistema);
        } else {
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = [];
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = await this.listaUltimasDispensasProduto(produtoSelecionado.numeroItemSistemaUnidade);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSizeUlimasDispensas.isEdit = true;
        this.modalCustomSizeUlimasDispensas.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSizeUlimasDispensas.formTitle = "Últimas dispensas";
        this.modalCustomSizeUlimasDispensas.isOpen = true;
        this.loading = false;
      }
    },

    async gerarPdfDeSolicitacao(solicitacao) {
      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Relatório de Solicitação",
        },
        content: [{ text: solicitacao.solicitarItem.descricaoSolicitarItem, style: "header" }],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            margin: [0, 0, 0, 24],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 16, 0, 8],
          },
          table: {
            margin: [0, 16, 0, 16],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 16, 0, 8],
          },
          columns: {
            columnGap: 20,
            margin: [0, 32, 0, 32],
          },
          assinatura: {
            columnGap: 20,
            margin: [0, 40, 0, 16],
          },
        },
        defaultStyle: {
          // alignment: 'justify'
        },
      };

      let response = await axios.put("itensSolicitar", { numeroSolicitarItem: solicitacao.solicitarItem.numeroSolicitacaoItem }, this.config);
      const listOfItensSolicitados = response.data;

      if (listOfItensSolicitados.length > 0) {
        let tabela = [
          { text: "Produtos Solicitados", style: "subtext" },
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "ID Solicitação", style: "tableHeader" },
                  { text: "ID Item", style: "tableHeader" },
                  { text: "Nome do Item", style: "tableHeader" },
                  { text: "Quantidade Solicitada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listOfItensSolicitados) {
          tabela[1].table.body.push([solicitacao.solicitarItem.numeroSolicitacaoItem, item.numeroItemSolicitar, item.nomeItemSistema, item.quantidadeSolicitada]);
        }

        docDefinition.content.push(tabela);
      }

      pdfMake.createPdf(docDefinition).open();
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    formatarQuantidade(quantidade) {
      if (quantidade) {
        return quantidade;
      } else {
        return "Sem Quantidade no Estoque";
      }
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    formataMes(mes) {
      switch (mes) {
        case 1:
          return "Janeiro";
        case 2:
          return "Fevereiro";
        case 3:
          return "Março";
        case 4:
          return "Abril";
        case 5:
          return "Maio";
        case 6:
          return "Junho";
        case 7:
          return "Julho";
        case 8:
          return "Agosto";
        case 9:
          return "Setembro";
        case 10:
          return "Outubro";
        case 11:
          return "Novembro";
        case 12:
          return "Dezembro";
      }
    },

    verificaUnidade(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return true;
        case 66:
          return true;
        case "67":
          return true;
        case "66":
          return true;
        default:
          return false;
      }
    },

    retornaNumeroUnidadeZSaude(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return 10;
        case 66:
          return 11;
        case "67":
          return 10;
        case "66":
          return 11;
      }
    },

    //#region VERIFICAÇÕES DE TOKENS
    async gerarNovoToken() {
      try {
        const response = await axios.post("/gerartoken", {}, this.config);

        await this.$store.dispatch("setToken", response.data.token);
        await this.$store.dispatch("setAuthenticatedState", true);

        if (response.data.token != this.config.headers["x-auth-token"]) {
          this.config.headers["x-auth-token"] = response.data.token;
        }

        this.initialize();
      } catch (error) {
        console.log(error);
      }
    },

    async verificarToken() {
      try {
        await axios.post("/verifyToken", {}, this.config);
      } catch (error) {
        alert("Tempo de autenticação expirado, por favor realize o login novamente.");

        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    //#endregion
  },
};
</script>
